import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
import CheckBox from "~/componentes/CustomForm/Check/styles/CheckBox";

import { Container } from './styles';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import Acoordion from '~/componentes/Acoordion';
import Button from '~/componentes/Button';
import IconLixeira from '~/assets/icones/IconLixeira.svg';

function CreateContent({ mountedData, analistas }) {
  const [meses, setMeses] = useState([]);
  const [anos, setAnos] = useState([]);
  const [ordensServicos, setOrdensServicos] = useState([]);
  const [ordensServicosCheck, setOrdensServicosCheck] = useState([]);
  const [checkTodos, setCheckTodos] = useState(true);

  const [horaTotal, setHoraTotal] = useState(0);
  const [mesAtivo, setMesAtivo] = useState(new Date().getMonth() + 1);
  const [anoAtivo, setAnoAtivo] = useState(new Date().getFullYear());
  const [ordensServicosAtivo, setOrdensServicosAtivo] = useState([]);
  const [analista, setAnalista] = useState({});

  useEffect(() => {
    let listaMeses = [
      { id: 1, sigla: "JAN", titulo: "Janeiro" },
      { id: 2, sigla: "FEV", titulo: "Fevereiro" },
      { id: 3, sigla: "MAR", titulo: "Março" },
      { id: 4, sigla: "ABR", titulo: "Abril" },
      { id: 5, sigla: "MAI", titulo: "Maio" },
      { id: 6, sigla: "JUN", titulo: "Junho" },
      { id: 7, sigla: "JUL", titulo: "Julho" },
      { id: 8, sigla: "AGO", titulo: "Agosto" },
      { id: 9, sigla: "SET", titulo: "Setembro" },
      { id: 10, sigla: "OUT", titulo: "Outubro" },
      { id: 11, sigla: "NOV", titulo: "Novembro" },
      { id: 12, sigla: "DEZ", titulo: "Dezembro" },
    ];
    setMeses(listaMeses);

    setAnos([
      { id: new Date().getFullYear() - 2 },
      { id: new Date().getFullYear() - 1 },
      { id: new Date().getFullYear() },
    ]);
  }, []);

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/fechamento/ordensservicos", { params: { idAnalista: analista?.id ? analista?.id : 0, mes: mesAtivo, ano: anoAtivo } })
      .then(response => setOrdensServicos(response.data));
  }, [analista, mesAtivo, anoAtivo]);

  useEffect(() => {
    let lista = [];
    for (let item of ordensServicos) {
      lista.push({ check: true, ...item });
    }

    setOrdensServicosCheck(lista);
    setOrdensServicosAtivo(lista);
  }, [ordensServicos]);

  useEffect(() => {
    let nHoraTotal = 0;
    let nMinTotal = 0;
    let lista = [];
    for (let item of ordensServicosCheck) {
      const indexFind = ordensServicosAtivo?.findIndex(e => e?.id == item?.id);

      if (indexFind > -1) {
        let nHora = parseInt(item?.horaTotal);
        let nMinuto = parseInt((item?.horaTotal * 100) - (parseInt(item?.horaTotal) * 100));

        nMinTotal += nMinuto;
        nHoraTotal += nHora;
      }
      lista.push({ ...item, check: (indexFind > -1 ? true : false) });
    }

    nHoraTotal += parseInt(nMinTotal / 60) + ((nMinTotal % 60) / 100);

    setHoraTotal(nHoraTotal);
    setOrdensServicosCheck(lista);
  }, [ordensServicosAtivo]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let ordensServicosLoca = [];

        for (const item of ordensServicosAtivo) {
          ordensServicosLoca.push({ id: item?.id });
        }

        let thisData = {
          ...data,
          mesAtivo,
          anoAtivo,
          ordensServicosAtivo: ordensServicosLoca,
          analista,
        };

        let response = await api.post("/signed/empresa/gestorprojeto/fechamentoos", thisData);
        if (response?.status === 200) {
          closeReload && closeReload();
        }

        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao cadastrar esse Fechamento de OS, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja cadastrar esse Fechamento de OS?`,
        successModal: `Fechamento de OS cadastrada com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são
            campos obrigatórios
          </p>
        </div>
        <div className="row">
          <div className="row">
            <Label title="Data Emissão*" className="col s12 m4 l2">
              <Input
                type="date"
                name="dataEmissao"
                required="true"
                readOnly="true"
                defaultValue={new Date().toISOString().split('T')[0]}
              />
            </Label>
            <Label title="Título *" className="col s12 m8 l4">
              <Input name="titulo" required="true" />
            </Label>
            <Label title="Analista *" className="col s12 m12 l2">
              <Select
                required="true"
                isString
                list={{
                  list: analistas,
                  value: 'id',
                  label: 'nome',
                }}
                name="idAnalista"
                firstOption
                onChange={e => {
                  const v = e.currentTarget.value || 0;
                  const analista = analistas?.find(e => e?.id == parseInt(v));
                  setAnalista(analista || {});
                }}
              />
            </Label>
            <Label title="Mês *" className="col s12 m12 l2">
              <Select
                required="true"
                isString
                list={{
                  list: meses,
                  value: "id",
                  label: "titulo",
                }}
                name="mesFechamento"
                defaultValue={new Date().getMonth() + 1}
                firstOption
                onChange={e => {
                  const v = e.currentTarget.value || 0;

                  setMesAtivo(parseInt(v));
                }}
              />
            </Label>
            <Label title="Ano *" className="col s12 m12 l1">
              <Select
                required="true"
                isString
                list={{
                  list: anos,
                  value: "id",
                  label: "titulo",
                }}
                name="anoFechamento"
                defaultValue={new Date().getFullYear()}
                firstOption
                onChange={e => {
                  const v = e.currentTarget.value || 0;

                  setAnoAtivo(parseInt(v));
                }}
              />
            </Label>
            <Label title="Total Hora" className="col s12 m2 l1">
              <Input
                name="totalHora"
                readOnly="true"
                value={horaTotal}
              />
            </Label>
          </div>
          <div className="row">
            <div className="col s12 m12 l12">
              <div className="header-os">
                <div className="header-left">
                  <p className="title_p">Ordens de Serviços *</p>
                </div>
                <div className="header-right">
                  <div className="check-all">
                    <p className="title_p">Marcar Todos</p>
                    {checkTodos ?
                      (
                        <div
                          className="card-check checked"
                          onClick={() => {
                            setOrdensServicosAtivo([]);
                            setCheckTodos(false);
                          }}
                        >
                          <span />
                        </div>
                      ) :
                      (
                        <div className="card-check"
                          onClick={() => {
                            let lista = [];
                            for (const itemAtivo of ordensServicosCheck) {
                              lista.push({ ...itemAtivo, check: true });
                            }
                            setOrdensServicosAtivo(lista);
                            setCheckTodos(true);
                          }}>
                          <span />
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div className="content-atividade">
                <div className="atv-content">
                  <div className="atv-content-top">
                    <div className="col col0-5 center">
                      <p className="ativo">#</p>
                    </div>
                    <div className="col col3">
                      <p>Título</p>
                    </div>
                    <div className="col col2">
                      <p>Analista</p>
                    </div>
                    <div className="col col1 center">
                      <p>Emissão</p>
                    </div>
                    <div className="col col1 center">
                      <p>Apontada</p>
                    </div>
                    <div className="col col1 center">
                      <p>Desconto</p>
                    </div>
                    <div className="col col1 center">
                      <p>Translado</p>
                    </div>
                    <div className="col col1 center">
                      <p>Total</p>
                    </div>
                    <div className="col col2">
                      <p>Coordenador</p>
                    </div>
                    <div className="col col1">
                      <p>Atv. Ent.</p>
                    </div>
                    <div className="col col0-5 center"> - </div>
                  </div>
                </div>
                {ordensServicosCheck?.map((item, index) => (
                  <div className="atv-content">
                    <div className="atv-content-top">
                      <div className="col col0-5">
                        <p className="ativo">#{item?.id}</p>
                      </div>
                      <div className="col col3">
                        <p>{item?.titulo}</p>
                      </div>
                      <div className="col col2">
                        <p>{item?.analista?.nome}</p>
                      </div>
                      <div className="col col1 center">
                        <p>{((new Date(item?.dataEmissao).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                      </div>
                      <div className="col col1 center">
                        <p>{item?.horaApontada}h</p>
                      </div>
                      <div className="col col1 center">
                        <p>{item?.horaDesconto}h</p>
                      </div>
                      <div className="col col1 center">
                        <p>{item?.horaTranslado}h</p>
                      </div>
                      <div className="col col1 center">
                        <p>{item?.horaTotal}h</p>
                      </div>
                      <div className="col col2">
                        <p>{item?.coordenador?.nome}</p>
                      </div>
                      <div className="col col1">
                        <p>{((new Date(item?.atividades[0]?.projetoAtividade?.previsaoEntrega).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                      </div>
                      <div className="col col0-5">
                        {item?.check == true ?
                          (
                            <div
                              className="card-check checked"
                              onClick={() => {
                                const itemFind = ordensServicosAtivo?.find(e => e?.id == item?.id);
                                let lista = [];
                                for (let itemOS of ordensServicosAtivo) {
                                  if (itemFind?.id != itemOS?.id) {
                                    lista.push(itemOS);
                                  }
                                }
                                setOrdensServicosAtivo(lista);
                              }}
                            >
                              <span />
                            </div>
                          ) :
                          (
                            <div className="card-check"
                              onClick={() => {
                                let lista = [];
                                for (const itemAtivo of ordensServicosAtivo) {
                                  lista.push(itemAtivo);
                                }

                                let indexFind = lista.findIndex((e) => e?.id == item?.id);
                                if (indexFind == -1) {
                                  lista.push(item);
                                }

                                setOrdensServicosAtivo(lista);
                              }}>
                              <span />
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateContent;
